module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ki-La.0c4313e9.png";